export const VERSION = {
  PROD: 'V. 3.13.0',
  QA: 'V. 5.21.1 (QA)',
}
